import { render, staticRenderFns } from "./SnapshotConfiguration.vue?vue&type=template&id=1b8c1deb"
import script from "./SnapshotConfiguration.vue?vue&type=script&lang=js"
export * from "./SnapshotConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports